import { useMediaQuery } from '@mui/material';
import { IBudgetService } from '../../createAndEdit/types';
import DetailServiceHeader from './DetailServiceHeader';
import DetailServiceItemsTable from './DetailServiceItemsTable';
import DetailServiceObservation from './DetailServiceObservation';

interface IDetailServicesSectionProps {
  service: IBudgetService;
  serviceIndex: number;
}

const DetailServicesSection = (props: IDetailServicesSectionProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const observation = props.service.observation;
  const hasObservation = observation && 
    typeof observation === 'string' && 
    observation.trim() !== '';
  
  return (
    <div className={`border border-gray-200 rounded-md ${isMobile ? 'p-3 my-4' : 'my-6'}`}>
      <DetailServiceHeader
        serviceId={props.service.serviceId}
        failureModeId={props.service.failureModeId}
        serviceIndex={props.serviceIndex}
      />
      <DetailServiceItemsTable
        items={props.service.items}
        serviceSubtotal={props.service.subtotal}
      />
      {hasObservation && observation && (
        <div className="mt-4 pl-4">
          <DetailServiceObservation observation={observation} />
        </div>
      )}
    </div>
  );
};

export default DetailServicesSection;
